import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import DemoReportCard from '../components/DemoReportCard';
import { Eye, Download } from 'lucide-react';

// This is a demo mode that bypasses Clerk for demonstration
export default function DemoMode() {
  const navigate = useNavigate();
  const [demoReports] = useState([
    {
      id: 'demo-1',
      client_name: 'Acme Restaurant Group',
      claimant_name: 'John Smith',
      status: 'completed',
      created_at: '2025-11-01T10:00:00Z',
      pdf_url: 'https://example.com/demo-report-1.pdf',
      result: {
        final_claim_amount: 507000
      },
      isDemoReport: true
    }
  ]);

  return (
    <div className="min-h-screen" style={{ background: 'var(--color-bg-base)' }}>
      <div className="container mx-auto px-4 py-8 max-w-6xl">
        <div
          className="p-4 mb-6"
          style={{
            background: 'var(--color-needs-human-tint)',
            borderLeft: '4px solid var(--color-brand)',
          }}
        >
          <div className="flex justify-between items-center">
            <p className="cs-body" style={{ color: 'var(--color-needs-human-text)' }}>
              <strong>DEMO MODE:</strong> This is a preview of the dashboard with sample data.
            </p>
            <Link
              to="/sign-in"
              className="font-semibold py-2 px-4 rounded-lg transition-colors"
              style={{ background: 'var(--color-brand)', color: 'var(--color-on-brand)' }}
            >
              Exit Demo → Sign In
            </Link>
          </div>
        </div>

        {/* Sample PDF Download Banner */}
        <div
          className="rounded-xl p-8 mb-8"
          style={{ background: 'var(--color-bg-surface)', border: '1px solid var(--color-border)' }}
        >
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <h2 className="cs-h2 mb-2" style={{ fontSize: '1.875rem' }}>View Sample Expert Report</h2>
              <p className="cs-body" style={{ fontSize: '1.125rem' }}>Acme Restaurant Group - Hurricane Claim ($507,000)</p>
              <p className="cs-meta mt-2">Complete report with statistical validation, BI calculations, and methodology</p>
            </div>
            <div className="flex gap-4">
              <a
                href={`${process.env.REACT_APP_BACKEND_URL}/api/v1/download/sample-pdf`}
                target="_blank"
                rel="noopener noreferrer"
                className="font-bold py-4 px-6 rounded-lg transition-colors text-lg whitespace-nowrap flex items-center"
                style={{ background: 'var(--color-bg-elevated)', color: 'var(--color-text-primary)', border: '1px solid var(--color-border)' }}
              >
                <Eye className="w-4 h-4 inline mr-1" aria-hidden="true" /> View PDF
              </a>
              <a
                href={`${process.env.REACT_APP_BACKEND_URL}/api/v1/download/sample-pdf-download`}
                className="font-bold py-4 px-6 rounded-lg transition-colors text-lg whitespace-nowrap flex items-center"
                style={{ background: 'var(--color-brand)', color: 'var(--color-on-brand)' }}
              >
                <Download className="w-4 h-4 inline mr-1" aria-hidden="true" /> Download
              </a>
            </div>
          </div>
        </div>

        <div className="flex justify-between items-center mb-8">
          <h1 className="cs-display" style={{ fontSize: '2.25rem' }}>The Figure Co. Dashboard</h1>
        </div>

        {/* Reports List */}
        <div
          className="rounded-xl p-6"
          style={{ background: 'var(--color-bg-surface)', border: '1px solid var(--color-border)' }}
        >
          <h2 className="cs-h2 mb-4">Recent Reports</h2>
          <div className="space-y-3">
            {demoReports.map((report) => (
              <DemoReportCard key={report.id} report={report} />
            ))}
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
          <div
            className="rounded-lg p-6"
            style={{ background: 'var(--color-bg-surface)', border: '1px solid var(--color-border)' }}
          >
            <h3 className="cs-label mb-2">Sample Report</h3>
            <p className="cs-figure-lg" style={{ fontSize: '1.875rem', color: 'var(--color-needs-human-text)' }}>1</p>
          </div>
          <div
            className="rounded-lg p-6"
            style={{ background: 'var(--color-bg-surface)', border: '1px solid var(--color-border)' }}
          >
            <h3 className="cs-label mb-2">Claim Amount</h3>
            <p className="cs-figure-lg" style={{ fontSize: '1.875rem' }}>$507K</p>
          </div>
          <div
            className="rounded-lg p-6"
            style={{ background: 'var(--color-bg-surface)', border: '1px solid var(--color-border)' }}
          >
            <h3 className="cs-label mb-2">Report Pages</h3>
            <p className="cs-figure-lg" style={{ fontSize: '1.875rem', color: 'var(--color-needs-human-text)' }}>16</p>
          </div>
        </div>
      </div>
    </div>
  );
}
